var fluid = {
  "width": "100% !important",
  "maxWidth": "none !important"
};

export { fluid };
